import { Controller } from "stimulus";
import "../vendor/add-to-calendar-button/atcb";

export default class extends Controller {
  static values = { config: Object };

  async open(event) {
    event.preventDefault();

    if (!this.hasConfigValue) {
      return;
    }

    try {
      if (typeof window.atcb_action !== "function") {
        throw new Error("Add to Calendar Button script is not loaded");
      }

      await window.atcb_action(this.configValue, this.element);
    } catch (error) {
      console.error(error);
    }
  }
}
